// MetaLabel — tiny uppercase tracked label used as section headers, eyebrow
// kickers above titles, and column captions. Mirrors the `.meta` class from
// tcs.css. Use sparingly — these read as quiet section dividers.

import type { ReactNode } from 'react';

export interface MetaLabelProps {
  children: ReactNode;
  className?: string;
}

export function MetaLabel({ children, className }: MetaLabelProps) {
  return (
    <div
      className={`text-[11px] font-semibold uppercase tracking-[0.08em] text-tcs-text-muted ${className ?? ''}`}
    >
      {children}
    </div>
  );
}
